module.exports = __webpack_public_path__ + "static/media/ic_language.d2146270.svg";